// A small, opinionated palette geared for analytics charts.
// Blues and purples as primary hues with subtle teals for contrast,
// matching the analytics mock.

export const ANALYTICS_PALETTE: readonly string[] = [
  "#2563EB", // blue 600
  "#7C3AED", // purple 600
  "#06B6D4", // cyan 500
  "#60A5FA", // blue 400
  "#8B5CF6", // violet 500
  "#0EA5E9", // sky 500
  "#A78BFA", // violet 400
  "#38BDF8", // sky 400
  "#93C5FD", // blue 300
  "#C084FC", // violet 400 light
  "#22D3EE", // cyan 400
  "#DDD6FE", // violet 200
] as const;

const hashStringToInt = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getColor = (key: number | string, offset = 0): string => {
  const index =
    typeof key === "number"
      ? key
      : (hashStringToInt(String(key)) + Math.abs(offset)) %
        ANALYTICS_PALETTE.length;
  return ANALYTICS_PALETTE[index % ANALYTICS_PALETTE.length];
};

export const getColors = (count: number, seed?: string): string[] =>
  Array.from({ length: count }, (_, i) => getColor(seed ? `${seed}-${i}` : i));

export type GetColor = typeof getColor;
export type GetColors = typeof getColors;
